<div data-test="modal-confirmar-exclusao" class="container">
    <mat-toolbar class="header">
        <i class="material-icons">delete_outline</i>
        <h2 matDialogTitle>{{data.title}}</h2>
    </mat-toolbar>

    <mat-dialog-content class="content">
        <div class="subtitle">
            <h1>{{data.subtitle}}</h1>
        </div>
        <span class="description">{{data.description}}</span>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="content">
        <button data-test="btn-cancelar-exclusao" mat-button matDialogClose="cancel" class="btn-cancel">{{ 'dialogDeleteProduct.cancel' | translate }}</button>
        <button data-test="btn-confirmar-exclusao" mat-button matDialogClose="confirm" class="btn-confirm">{{ 'dialogDeleteProduct.delete' | translate }}</button>
    </mat-dialog-actions>
</div>